import './forms.css'
import NewMatterForm from './NewMatter'
import NewOrderForm from './NewOrder'

export default {
    NewMatter : NewMatterForm,
    NewOrder : NewOrderForm
}